import { FC } from "react";
import cx from "classnames";
import { useLocation } from "react-router-dom";

import RouterView from "../../libs/RouterView";
import { pagesRoutes } from "../routes/config";
import { getActiveRoute } from "../../helpers/getActiveRoute";
import { RouteType } from "../routes/types";
import EditModePagesLoading from "./components/Skeletons/EditModePagesLoading";

import styles from "./styles.module.scss";

const Pages: FC = () => {
    const location = useLocation();

    const activeRoute = getActiveRoute(location.pathname);

    return (
        <div className={styles.wrapper}>
            <div className={cx(styles.bar, { [styles.inPreviewMode]: activeRoute === RouteType.Preview })}>
                <RouterView routes={pagesRoutes} fallback={EditModePagesLoading} />
            </div>
        </div>
    );
};

export default Pages;
